export default function Footer() {
    return (
        <footer className='footer'>
            <small className="footer">by <a href="https://github.com/will-s-205/airbnb-clone">William Step</a></small>
        </footer>
    )
}